import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useNotification } from '../../contexts/NotificationContext';
import { authFetch } from "../../utils/authFetch";

const NovoUsuario = () => {

    const [name, setName] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [roles, setRoles] = useState([]);
    const [userRoleId, setUserRoleId] = useState(1);
    const { showNotification } = useNotification();

    const navigate = useNavigate();    

    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const response = await authFetch('user-role', {
                    method: "GET",                    
                });

                if (!response.ok) {
                    throw new Error("Erro ao buscar roles");
                }

                const data = await response.json();
                setRoles(data); // Atualiza a lista de perfis de acesso
            } catch (error) {
                console.error("Erro ao buscar roles:", error);
                showNotification("danger", "Erro ao carregar roles");
            }
        };
        
            fetchRoles();        
    }, [showNotification]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Verifica se as senhas coincidem
        if (password !== confirmPassword) {
            alert("As senhas não coincidem!");
            return;
        }

        const userData = {
            username,
            name,
            userRoleId: Number(userRoleId), // Certificando que é um número
            password
        };        

        try {
            const response = await authFetch('user', {
                method: "POST",                
                body: JSON.stringify(userData), // Convertendo o objeto para JSON
            });

            if (!response.ok) {
                throw new Error("Erro ao criar usuário");
            }            

            showNotification("success", "Usuário gerado com sucesso!");
            navigate("/Usuarios");
        } catch (error) {
            console.error("Erro:", error);
            showNotification("danger", "Erro ao gerar usuário");
        }
    };

    return (
        <div className="card">
            <div className="card-body p-3">
                <div className="row">
                    <aside className="column">
                        <div className="side-nav">
                            <h4 className="font-weight-bolder mb-0">Novo Usuário</h4>
                        </div>
                    </aside>
                    <div className="column-responsive column-80">
                        <div className="usuarios form content">
                            <form onSubmit={handleSubmit}>
                                <fieldset className="col-md-6">
                                    <label htmlFor="nome">Nome</label>
                                    <input type="text" name="name" id="name" className="form-control form-control-sm" onChange={(e) => setName(e.target.value)} />
                                    <label htmlFor="email">Email</label>
                                    <input type="text" name="username" id="username" className="form-control form-control-sm" onChange={(e) => setUsername(e.target.value)} />
                                    <label htmlFor="senha">Senha</label>
                                    <input type="password" name="password" id="password" className="form-control form-control-sm" onChange={(e) => setPassword(e.target.value)} />
                                    <label htmlFor="confirmarsenha">Confirmar Senha</label>
                                    <input type="password" name="confirmpassword" id="confirmpassword" className="form-control form-control-sm" onChange={(e) => setConfirmPassword(e.target.value)} />
                                    <label htmlFor="perfilacesso">Perfil de Acesso</label>
                                    <select name="userRoleId" id="userRoleId" className="form-control form-control-sm" value={userRoleId} onChange={(e) => setUserRoleId(e.target.value)}>
                                        {roles.filter(role => Number(role.id) !== 3).map((role) => (
                                            <option key={role.id} value={role.id}>
                                                {role.name}
                                            </option>
                                        ))}
                                    </select>
                                    {/* <label htmlFor="foto">Foto</label>
                                    <input type="file" name="foto" id="foto" className="form-control form-control-sm" onChange={(e) => setFoto(e.target.value)} /> */}
                                    <div className="card-footer" style={{ paddingLeft: "0" }}>
                                        <Link to={'/Usuarios'} className="btn btn-info btn-sm" >Voltar</Link>
                                        <button type="submit" className="btn btn-primary btn-sm">Salvar</button>
                                    </div>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NovoUsuario